import React, {useEffect, useState} from "react";
import {withNamespaces} from "react-i18next";
import Papa from "papaparse";
import * as XLSX from 'xlsx';
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {Formatter} from "../../../helpers/formatter";
import {networkDeviceService} from "../../../services/network-device.service";
import {toastr} from 'react-redux-toastr'

const ImportNetworkDevice = ({t}) => {
    const [nameToKey,setNameToKey] = useState([]);
    const [fileData, setFileData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [mapping, setMapping] = useState({});
    const [descriptionColumns, setDescriptionColumns] = useState([]);
    const [isImport, setIsImport] = useState(false);
    const [resultList, setResultList] = useState();

    useEffect(() => {
        setNameToKey([
            { key: "hostname", label: t('hostname')},
            { key: "ipAddress", label: t('ip-address')},
            { key: "mac",  label: t('mac')},
            { key: 'deviceTypeId', label: t('deviceType')}
        ])
    }, [t]);

    useEffect(() => {
        console.log(`Change detection is import: ${isImport}`)
    }, [isImport]);

    const parseToModel = (value) => {
        return {
            IpAddress: value.ipAddress,
            Label: value.hostname,
            Description: value.description ? value.description : "",
            Port: value.port ? value.port : null,
            DeviceTypeId: value.deviceTypeId ? value.deviceTypeId : 1,
            Mac: value.mac ? value.mac.replaceAll(":", "-") : ""
        }
    }

    const handleFileUpload = (event) => {
        setResultList(null);

        const file = event.target.files[0];
        if(!file) return;

        const reader = new FileReader();
        const isCsv = file.name.endsWith(".csv");

        reader.onload = (e) => {
            const data = e.target.result;
            if(isCsv) {
                const parsed = Papa.parse(data, { header: true });
                setFileData(parsed.data);
                setColumns(parsed.meta.fields);
            }
            else {
                const workbook = XLSX.read(data, {type: "binary"});
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet, {header: 1});
                setColumns(jsonData[0]);
                setFileData(jsonData.splice(1).map((row) => {
                    return jsonData[0].reduce((acc, col, i) => {
                        acc[col] = row[i];
                        return acc;
                    }, {})
                }));
            }
        }

        if(isCsv) {
            reader.readAsText(file);
        }
        else {
            reader.readAsBinaryString(file);
        }
    }

    const handleMappingChange = (property, column) => {
        setMapping({...mapping, [property]: column});
    }

    const handleDescriptionColumnsChange = (column) => {
        setDescriptionColumns((prev) => {
            if(prev.includes(column)) {
                return prev.filter((col) => col !== column);
            }
            else {
                return [...prev, column];
            }
        });
    };

    const handleImport = () => {
        setIsImport(true);
        const mappedData = fileData.map((row) => {
            const mappedRow = {};
            Object.entries(mapping).forEach(([property, column]) => {
                mappedRow[property] = row[column];
            });
            if(descriptionColumns.length > 0) {
                mappedRow.description = descriptionColumns
                    .map((col) => row[col])
                    .filter(Boolean)
                    .join(" ");
            }
            return mappedRow;
        })
        const results = mappedData.map((row) => {
            if(row.hostname && row.ipAddress && Formatter.isIpAddress(row.ipAddress)) {
                if(!Formatter.isEmpty(row.mac) && !Formatter.isMacAddress(row.mac)) {
                    return { success: false, data: row };
                }
                else {
                    return { success: true, data: row };
                }

            }
            return {success: false, error: "Missing required fields"};
        });
        const successCount = results.filter((r) => r.success).length;
        const errorCount = results.length - successCount;

        const deviceToImport = results.filter((r) => r.success).map((item) => parseToModel(item.data));
        networkDeviceService.addNetworkDevices(deviceToImport)
            .then((response) => {
                const {validItems, invalidItems} = separateValidAndInvalidItems(response, deviceToImport);

                console.log(validItems);
                console.log(invalidItems);

                setResultList({failure: invalidItems, success: validItems });
            })
            .catch(error => {
                console.log(error);
                toastr.error('error', "server error")
            })
            .finally(() => setIsImport(false))
    };

    const separateValidAndInvalidItems = (errors, items) => {
        const errorMap = new Map(errors.map(e => [e.error, e.errorMessages]));
        const validItems = [];
        const invalidItems = [];

        items.forEach(item => {
            if (errorMap.has(item.Label)) {
                invalidItems.push({ error: item.Label, errorMessages: errorMap.get(item.Label) });
            } else {
                validItems.push(item);
            }
        });

        return { validItems, invalidItems };
    }

    const breadcrumb = [{ value: 'imports', path: '#' }];

    return (
        <div>
            <BreadcrumbExtend items={breadcrumb}/>
            <div className="row">
                <h4 className="col-md-6">{t('import')} - {t('network-devices')}</h4>
            </div>
            <div className="card">
                { isImport && (
                    <div className="overlay">
                        <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                    </div>
                ) }
                <div className="card-body">
                    <div className="container-fluid mt-2">
                        <div className="form-group">
                            <label htmlFor="fileUpload">{t('select-file')}</label>
                            <div className="input-group">
                                <div className="custom-file">
                                    <input
                                        type="file"
                                        className="custom-file-input"
                                        id="fileUpload"
                                        accept=".csv,.xlsx"
                                        onChange={handleFileUpload}
                                    />
                                    <label className="custom-file-label" htmlFor="exampleInputFile">{t('select-file')}</label>
                                </div>
                            </div>
                        </div>

                        { resultList?.success && resultList?.success?.length > 0 && (
                            <div className="alert alert-success">
                                <h5>{t('list-of-success')}</h5>
                                <ul>
                                    {resultList?.success.map((item, idx) => {
                                        console.log(resultList?.failure)
                                        if(resultList?.failure.includes((x) => {
                                            return x.error === item.Label
                                        })) return;
                                        return (
                                            <li key={`err-${idx}`}>
                                                <b>{ item.Label }</b>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        ) }
                        
                        { resultList?.failure && resultList?.failure?.length > 0  && (
                            <div className="alert alert-danger">
                                <h5>{t('list-of-failure')}</h5>
                                <ul>
                                    {resultList?.failure.map((item, idx) => {
                                        const formated = Formatter.errorViewModelToKeyValPair(item.errorMessages);
                                        return (
                                            <li key={`err-${idx}`}>
                                                <b>{ item.error }</b>
                                                <ul>
                                                    {formated.map((val, idxx) => {
                                                        return (
                                                            <li key={`err-item-${idxx}`}>
                                                                <b>{t(`validation.key.${val.key}`)}</b> - {t(`validation.${val.value}`)}
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        ) }

                        {columns.length > 0 && !resultList  && (
                            <div className="mt-4">
                                <h3>{t("import-settings")}</h3>
                                <div className="row">
                                    {nameToKey.map(({key, label}) => (
                                        <div key={key} className="col-md-4">
                                            <div className="form-group">
                                                <label>{label}</label>
                                                <select
                                                    className="form-control"
                                                    value={mapping[key] || ''}
                                                    onChange={(e) => handleMappingChange(key, e.target.value)}
                                                >
                                                    <option value="">-- {t('select-column')} --</option>
                                                    {columns.map((col) => (
                                                        <option key={col} value={col}>
                                                            {col}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="form-group">
                                    <label>{t("import-description")}</label>
                                    {columns.map((col) => (
                                        <div key={col} className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                value={col}
                                                checked={descriptionColumns.includes(col)}
                                                onChange={() => handleDescriptionColumnsChange(col)}
                                            />
                                            <label className="form-check-label">{col}</label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {fileData.length > 0  && !resultList  && mapping.hostname && mapping.ipAddress && (
                            <button
                                className="btn btn-primary mt-4"
                                onClick={() => handleImport()}
                                disabled={isImport}
                            >
                                {t("import")}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withNamespaces()(ImportNetworkDevice);
